import React from 'react';
import {PortfolioImage} from '../../assets/images/index';
import {SunPharmaImage, RubaminImage,AMGreenImage,PodarWonderSchool,JCBCompany,UnitedWayImage, Windar, Himcast, GeVeroma, Nargarujna} from '../../assets/icons/portfolio_icon/index'
import {motion} from 'framer-motion'

const Portfolio = () => {

    const splitTextArray = (text) => {
        return text.split("").map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: -10 }} // Start slightly above
            animate={{ opacity: 1, y: 0 }}   // Animate to normal position
            transition={{
              delay: index * 0.05, // Faster staggered effect for characters
              duration: 0.3,
              ease: "easeOut",
            }}
            className="inline-block"
          >
            {char === " " ? "\u00A0" : char} {/* Preserve spaces */}
          </motion.span>
        ));
      };
    return (
        <div>
             <motion.div
        className="bg-cover bg-center bg-no-repeat w-full h-screen min-h-[300px] backdrop-blur-sm"
        style={{
          backgroundImage: `url(${PortfolioImage})`,
          backgroundSize: 'cover', // Cover the entire container (ensure the image always covers the space)
          backgroundPosition: 'center', // Keep the image centered
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1, y: 0 }} // Slide in from the top when in view
        viewport={{ once: true }} // Triggers animation when in view
            >
                <div className="flex justify-center items-center my-auto flex-col gap-[15px] fontText">
                    <div className="font-semibold text-[65px] text-[#ffffff] mt-[200px] max-md:text-[42px]">
                    {splitTextArray('Our Portfolio')}
                    </div>
                </div>
            </motion.div>
            <div className='container py-[100px]'>
                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                    {splitTextArray('Sun Pharmaceutical Industries Ltd')}
                    </h4>
                <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 2, delay: 1.2 }}
                            whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                            viewport={{ once: true }}
                className='flex flex-row items-center gap-[10px] max-md:gap-[30px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            At Shree Dattguru Enterprise, we had the privilege of partnering with Sun Pharma to deliver a range of impactful services. Our work included the construction of Anganwadis, schools, and educational children’s gardens to foster community development and support the education sector. We also contributed to improving local infrastructure by helping build wells and installing an RO water plant, ensuring access to clean water for the community. Our team’s commitment to quality and sustainability helped us successfully complete these projects, creating a lasting positive impact in the areas we served.
                        </p>
                    </div>
                    <div className='w-[50%] max-md:w-[100%] max-md:px-[20px] flex justify-center items-center'>
                        <img src={SunPharmaImage} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>
                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('Rubamin Pvt. Ltd.')}
                </h4>
                <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 2, delay: 1.4 }}
                            whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                            viewport={{ once: true }}
                     className='flex flex-row-reverse items-center gap-[10px] max-md:gap-[30px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise partnered with Rubamin to contribute to the development and improvement of educational infrastructure. Our team was involved in building a school, setting up smart classrooms, and constructing well-designed toilets to enhance the learning environment. Additionally, we carried out extensive electricity renovation work and multi-shade painting, bringing a fresh and modern look to the school. Each project was executed with precision and care, ensuring functionality and aesthetic appeal to meet the needs of students and staff alike.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={RubaminImage} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>

                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('JCB Company India Pvt')}
                </h4>
                <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2, delay: 1.4 }}
                whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                viewport={{ once: true }}
                className='flex flex-row items-center gap-[10px] max-md:gap-[30px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                        Shree Dattguru Enterprise collaborated with JCB on multiple infrastructure projects, including the construction of Anganwadis to support early childhood development. Our team also provided high-quality painting services, giving the facilities a fresh and vibrant appearance. Additionally, we handled electrical work, ensuring that all installations were up to safety standards and fully functional. Our commitment to excellence in every aspect of the project helped deliver a successful outcome, positively impacting the communities served by these initiatives.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={JCBCompany} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>
                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('AM Green Group')}
                </h4>
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 1.6 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row-reverse items-center  max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise worked closely with AM Green on several key infrastructure projects. Our team successfully completed the construction of a border wall, enhancing security and boundary protection. We also provided comprehensive services including high-quality painting, electrical work, and building renovations, transforming existing structures to meet modern standards. Additionally, we supplied skilled labor to ensure timely and efficient project completion. Our dedication to quality craftsmanship and professionalism contributed to the successful execution of these initiatives.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px] '>
                        <img src={AMGreenImage} className='rounded-[10px] w-[500px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>

                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('Podar Internation School')}
                </h4>
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 1.8 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise partnered with Podar International School to enhance their infrastructure. Our team provided key services, including the construction of title work, high-quality painting, and plumbing installations. Additionally, we were responsible for building the common school kitchen, ensuring that it met all necessary standards for safety and functionality. Each task was completed with precision, contributing to the overall improvement of the school environment and facilities for students and staff alike.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={PodarWonderSchool} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>

                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('United Way of Baroda')}
                </h4> 
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 2.0 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row-reverse items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                           Shree Dattguru Enterprise collaborated with United Way of Baroda to carry out several impactful projects across Gujarat. Our team was responsible for setting up RO machines to provide clean drinking water, ensuring access to safe water for the communities. Additionally, we handled plumbing work and constructed female toilets in five different districts, significantly improving sanitation facilities. Our efforts contributed to enhancing both the infrastructure and the quality of life for the people in these regions.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={UnitedWayImage} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>


                <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('Windar Company')}
                </h4>
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 1.8 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                         Shree Dattguru Enterprise partnered with Windar Company to deliver essential infrastructure services that support operational efficiency and community development.
Our team provided comprehensive plumbing services, ensuring reliable water systems that meet industrial standards. We also undertook the construction of robust RCC roads to facilitate smooth transportation within the facility premises. In addition, we constructed durable boundary and internal walls to enhance structural integrity and site security.</p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center  max-md:px-[20px]'>
                        <img src={Windar} className='rounded-[10px] min-w-[350px] max-md:!min-w-[280px]' alt=""/>
                    </div>
                </motion.div>

 <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('Himcast Company')}
                </h4> 
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 2.0 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row-reverse items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise collaborated with Himcast Company to deliver a range of essential services that supported both infrastructure development and daily operations.
Our scope of work included the construction of sturdy boundary and internal walls, supply of skilled and unskilled labor, and various on-site support services. With a focus on quality workmanship and dependable service, we contributed to creating a safer and more efficient working environment for the Himcast team.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={Himcast} className='rounded-[10px] min-w-[280px]' alt=""/>
                    </div>
                </motion.div>


 <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('GE VERNOVA')}
                </h4>
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 1.8 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise partnered with GE Vernova to support critical site infrastructure and manpower needs.
Our team provided reliable labor supply along with essential civil work services, including wall construction and other site development tasks. With a strong emphasis on safety, quality, and timely execution, we helped maintain smooth operations and contributed to the overall efficiency of the project.
        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center  max-md:px-[20px]'>
                        <img src={GeVeroma} className='rounded-[10px] min-w-[350px] max-md:!min-w-[280px]' alt=""/>
                    </div>
                </motion.div>


                 <h4 className='flex items-center justify-center text-[22px] font-semibold fontText'>
                {splitTextArray('Nagarjuna NACL')}
                </h4> 
                <motion.div 
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 transition={{ duration: 2, delay: 2.0 }}
                 whileInView={{ opacity: 1, y: 0 }} // slide in from the top when in view
                 viewport={{ once: true }}
                className='flex flex-row-reverse items-center max-md:gap-[30px] gap-[10px] max-md:flex-col-reverse py-[50px]'>
                    <div className='w-[50%] max-md:text-center max-md:w-[100%] max-md:px-[20px]'>
                        <p>
                            Shree Dattguru Enterprise collaborated with Nagarjuna NACL to deliver a comprehensive range of civil and infrastructure services.
Our work included building construction, well construction, and the development of RCC roads to improve site accessibility. We also carried out wall construction and plumbing installations, ensuring functional and durable infrastructure. Each service was executed with a focus on quality, safety, and long-term utility, contributing to the smooth operation and sustainability of the facility.
                        </p>
                    </div>
                    <div className='w-[50%] flex justify-center items-center max-md:w-[100%] max-md:px-[20px]'>
                        <img src={Nargarujna} className='rounded-[10px] min-w-[280px] min-h-[200px]' alt=""/>
                    </div>
                </motion.div>

            </div>
        </div>
    );
};

export default Portfolio;
